/**
 * Path: src/store/utils/editorUtils.ts
 * Task: Pure utility functions for the editor store.
 * Fix: Removed synchronizeRelationships as bidirectional consistency is now natively handled by the SQLite backend.
 */

import type { Entity, EntityType } from '@/core/types/editor';

/**
 * Calculates the next available rank for a given entity type collection.
 * Useful for orderable lists.
 * * @param data The current datastore object containing all entity collections.
 * @param entityType The specific entity collection to calculate the next rank for.
 * @returns The next sequential rank integer.
 */
export function getNextRank(data: Record<string, Entity[]> | null | undefined, entityType: EntityType): number {
  if (!data || !data[entityType] || !Array.isArray(data[entityType]) || data[entityType].length === 0) {
    return 1;
  }
  const list = data[entityType];
  const maxRank = Math.max(...list.map((e: Entity) => e.rank || 0));
  return maxRank + 1;
}
